export default "__VITE_ASSET__cNtNG9Q3__"